import { render, staticRenderFns } from "./getDriverwalletCSV.vue?vue&type=template&id=0f52fe48&scoped=true&"
import script from "./getDriverwalletCSV.vue?vue&type=script&lang=js&"
export * from "./getDriverwalletCSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52fe48",
  null
  
)

export default component.exports